import { useMutation, useQueryClient } from '@tanstack/react-query'
import { coreInstance } from 'shared/axios'
import { strings } from 'shared/translations'
import { showToast } from 'shared/ui'
import { CurrentUser } from './CurrentUser'
import { QUERY_KEYS } from './queryKey'

type Args = { id: string } & Pick<CurrentUser, 'socialLinks' | 'settings'>

export const updateUserInfo = ({ id, socialLinks, settings }: Args) =>
  coreInstance.patch(`/osm/employees/${id}`, {
    employee: { socialLinks, settings },
  })

export const useUpdateUserInfo = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateUserInfo,
    onSuccess: () => {
      showToast('success', strings.NOTIFICATION.UPDATED_PERSONAL_INFO)

      return queryClient.invalidateQueries({ queryKey: QUERY_KEYS.profile })
    },
  })
}
